import _Model from "./_Model";
import ServicePlanItem from "./ServicePlanItem";
import SoftwareLicence from "./SoftwareLicence";

export default class SoftwareLicenseSelection extends _Model {
  constructor(json) {
    super(json);
    this.softwareSelection = SoftwareLicenseSelection.getOrDefault(json, 'softwareSelection', null);
    this.softwareLicences = SoftwareLicenseSelection.getMappedOrDefault(json, 'softwareLicences', [], data => (data || []).map(l => new SoftwareLicence(l)));
    this.servicePlanItems = SoftwareLicenseSelection.getMappedOrDefault(json, 'servicePlanItems', [], data => (data || []).map(i => new ServicePlanItem(i)));
    this.servicePlanActivated = SoftwareLicenseSelection.getOrDefault(json, 'servicePlanActivated', true);
  }
}
